import {TComponentRef} from '../FormField';

enum ETimePickerType {
  HMS = 'HMS',
  HM = 'HM',
  MS = 'MS',
}

enum ETimePeriod {
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  SECONDS = 'SECONDS',
}

const PERIODS = Object.values(ETimePeriod);

type TTime = {
  [ETimePeriod.HOURS]?: number;
  [ETimePeriod.MINUTES]?: number;
  [ETimePeriod.SECONDS]?: number;
};

type TTimePickerType = keyof typeof ETimePickerType;

type TTimePickerProps = TComponentRef & {
  type?: TTimePickerType;
  className?: string;
  isInvalid?: boolean;
  dataSelector?: string;
  minTime?: string | Date | null;
  maxTime?: string | Date | null;
  hasAcceptButton?: boolean;
  name?: string;
  value?: string | Date | null;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: (value: string, date: Date) => void;
  onFocus?: TEmptyFunction;
  onBlur?: TEmptyFunction;
  placeholder?: string;
};

const OPTION_HEIGHT = 36;

const hourOptions = new Array(24).fill(1).map((_, index) => index);
const minuteOptions = new Array(60).fill(1).map((_, index) => index);
const secondOptions = new Array(60).fill(1).map((_, index) => index);

const TIME_OPTIONS = {
  [ETimePeriod.HOURS]: hourOptions,
  [ETimePeriod.MINUTES]: minuteOptions,
  [ETimePeriod.SECONDS]: secondOptions,
};

const EMPTY_OPTIONS = new Array(5).fill(1);

const MILLISECONDS = 0;

const MIN_TIME = 0;

const MAX_TIME = {
  [ETimePeriod.HOURS]: 23,
  [ETimePeriod.MINUTES]: 59,
  [ETimePeriod.SECONDS]: 59,
};

const DEFAULT_WIDTH = {
  [ETimePickerType.HMS]: '150px',
  [ETimePickerType.HM]: '110px',
  [ETimePickerType.MS]: '110px',
};

export {
  DEFAULT_WIDTH,
  OPTION_HEIGHT,
  TIME_OPTIONS,
  EMPTY_OPTIONS,
  ETimePickerType,
  ETimePeriod,
  MIN_TIME,
  MAX_TIME,
  MILLISECONDS,
  PERIODS,
};
export type {TTime, TTimePickerProps, TTimePickerType};
